import { ImageComponent } from '@/components/Image';
import { ScBenefitItem } from './styled';

interface IBenefitItemProps {
  description: string;
  imgUrl: string;
  subTitle: string;
  title: string;
}

export const BenefitItem = ({
  description,
  imgUrl,
  subTitle,
  title,
}: IBenefitItemProps) => (
  <ScBenefitItem>
    <div className="item-container">
      <div className="text-wrapper">
        <span className="title">{title}</span>
        <span className="subtitle">{subTitle}</span>
      </div>
      <ImageComponent alt="benefit-icon" height={64} src={imgUrl} width={70} />
    </div>
    <span className="description">{description}</span>
  </ScBenefitItem>
);
